<h2 mat-dialog-title>Confirm Payment Transfer</h2>
<mat-dialog-content class="mat-typography">
  <span style="font-size: 18px;">Click continue to confirm transferring {{data.amount | currency}} to Invoice Number: {{data.invoiceNumber}}</span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light btn-sm" 
        style="margin-right:10px;"
        [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
